import React from 'react';
import { useIntl } from 'react-intl';
import { compact, isEmpty } from 'lodash';

import { RecordDataItem, SearchInstanceDto } from '@app/components';

interface PublicationInfoProps {
  publication?: SearchInstanceDto['publication'];
}

export const PublicationInfo: React.FC<PublicationInfoProps> = ({
  publication,
}) => {
  const { $t } = useIntl();

  const publicationDetails = compact([
    publication?.[0]?.publisher,
    publication?.[0]?.place,
    publication?.[0]?.dateOfPublication,
  ]);

  if (isEmpty(publicationDetails)) {
    return null;
  }

  return (
    <RecordDataItem
      label={$t({
        id: 'resultsList.published',
        defaultMessage: 'Published:',
      })}
      data-auto="publication-info"
    >
      <span>{publicationDetails.join(', ')}</span>
    </RecordDataItem>
  );
};
